<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text  Aprobación de Imágenes de Clientes

    v-dialog(v-model='dialog', persistent max-width='700px')
      v-container(style='background-color:white !important;max-width: 700px;')
        v-card-title.justify-center
          span.headline Detalles de la Imagen
        v-card-text
          v-container(grid-list-md)
            v-layout(wrap)
              v-flex(xs12, sm6)
                v-text-field(
                  v-model='form.cliente',
                  label='Cliente',
                  readonly
                  outline
                )
              v-flex(xs12, sm6)
                v-text-field(
                  v-model='form.vendedor',
                  label='Vendedor',
                  readonly
                  outline
                )
              v-flex(xs12)
                v-img(
                  :src="form.imagen ? `${ruta}${form.imagen}` : ''"
                  max-height="300"
                  contain
                  v-if="form.imagen"
                )
                v-card-text(v-else) No hay imagen disponible
              v-flex(xs12)
                v-textarea(
                  v-model='form.observacion',
                  label='Observación',
                  :disabled="form.estatus === 'Aprobado'"
                  outline
                )
        v-card-actions(style="justify-content: center;")
          v-layout(row wrap justify-center)
            v-btn(
              v-if="form.estatus === 'Pendiente'"
              style="background:green;border-radius:10px; margin: 0 5px;" 
              flat 
              @click="aprobarImagen"
              :loading="loading"
            ) Aprobar
            v-btn(
              v-if="form.estatus === 'Pendiente'"
              style="background:red;border-radius:10px; margin: 0 5px;" 
              flat 
              @click="rechazarImagen"
              :loading="loading"
            ) Rechazar
            v-btn(
              style="background:black;border-radius:10px; margin: 0 5px;" 
              flat 
              @click="close"
              :disabled="loading"
            ) Cerrar

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Solicitudes
        v-data-table.elevation-1(
          :headers='headers',
          :items='solicitudes',
          :loading='loading',
          :pagination.sync='pagination',
          style="margin-top: 5px;"
        )
          template(slot='items', slot-scope='props')
            td(v-if='props.item.imagen')
              img(
                :src="`${ruta}${props.item.imagen}`"
                style='height:60px;width:60px;object-fit:contain;cursor:pointer;'
                @click='verDetalles(props.item)'
                :alt="props.item.imagen"
              )
            td(v-else) - -
            td {{ (props.item.cliente && props.item.cliente) || 'N/A' }}
            td {{ (props.item.vendedor && props.item.vendedor) || 'N/A' }}
            td {{ formatDate(props.item.fechaCreacion) }}
            td
              v-chip(
                :color="getStatusColor(props.item.estatus)"
                dark
                small
              ) {{ props.item.estatus | capitalize }}
            td
              v-btn.mx-0(
                icon,
                @click='verDetalles(props.item)',
                :disabled="loading"
                title="Ver detalles"
              )
                v-icon(color='green') visibility
</template>

<script>
import Api from "@/services/methods";
import moment from 'moment';
import { serverImg } from "@/services/environment";

export default {
  name: "ImagenClientes",
  data: () => ({
    ruta: serverImg,
    loading: false,
    dialog: false,
    solicitudes: [],
    form: {
      _id: null,
      cliente: '',
      co_cli: '',
      co_ven: '',
      vendedor: '',
      imagen: '',
      estatus: 'Pendiente',
      observacion: '',
      fechaCreacion: null
    },
    headers: [
      { text: 'Imagen', sortable: false },
      { text: 'Cliente', value: 'cliente' },
      { text: 'Vendedor', value: 'vendedor' },
      { text: 'Fecha', value: 'fechaCreacion' },
      { text: 'Estado', value: 'estatus', width: '120px' },
      { text: 'Acciones', sortable: false, width: '100px' }
    ],
    pagination: {
      sortBy: 'fechaCreacion',
      descending: true,
      rowsPerPage: 10
    },
    cre: "",
    mod: "",
    elm: ""
  }),
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  created() {
    this.verificacion();
    this.cargarSolicitudes();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.adminsafiro.permisos.length; i++) {
        if (this.$store.state.adminsafiro.permisos[i].ruta === "ImagenClientes") {
          for (
            let j = 0;
            j < this.$store.state.adminsafiro.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    async cargarSolicitudes() {
      try {
        this.loading = true;
        const res = await Api.get('clienteImagen');
        this.solicitudes = res.data;
      } catch (error) {
        console.error('Error al cargar solicitudes:', error);
        this.$swal('Error', 'No se pudieron cargar las solicitudes', 'error');
      } finally {
        this.loading = false;
      }
    },
    verDetalles(item) {
      this.form = { ...item };
      this.dialog = true;
    },
    async aprobarImagen() {
      try {
        this.loading = true;
        await Api.post(`clienteImagen/${this.form._id}/aprobar`);
        this.$swal('¡Éxito!', 'Imagen aprobada correctamente', 'success');
        this.close();
        this.cargarSolicitudes();
      } catch (error) {
        console.error('Error al aprobar imagen:', error);
        this.$swal('Error', 'No se pudo aprobar la imagen', 'error');
      } finally {
        this.loading = false;
      }
    },
    async rechazarImagen() {
      if (!this.form.observacion) {
        this.$swal('Advertencia', 'Debe ingresar una observación para rechazar', 'warning');
        return;
      }
      
      try {
        this.loading = true;
        await Api.post(`clienteImagen/${this.form._id}/rechazar`, {
          observacion: this.form.observacion
        });
        this.$swal('¡Éxito!', 'Imagen rechazada correctamente', 'success');
        this.close();
        this.cargarSolicitudes();
      } catch (error) {
        console.error('Error al rechazar imagen:', error);
        this.$swal('Error', 'No se pudo rechazar la imagen', 'error');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.form = {
        _id: null,
        cliente: '',
        vendedor: '',
        imagen: '',
        estatus: 'Pendiente',
        observacion: '',
        fechaCreacion: null
      };
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY HH:mm') : 'N/A';
    },
    getStatusColor(estatus) {
      const colors = {
        Pendiente: 'orange',
        Aprobado: 'green',
        Rechazado: 'red'
      };
      return colors[estatus] || 'grey';
    }
  }
};
</script>

<style scoped>
.v-dialog {
  overflow-y: hidden !important;
}
</style>
